module.exports = __webpack_public_path__ + "static/bolla-fe828bfca68d0aea9f7074b90ac5a76c.jpg";